import { useMutation } from '@tanstack/react-query';
import { ColumnFiltersState, SortingState } from '@tanstack/react-table';
import { format } from 'date-fns';
import { snakeCase } from 'lodash';

import { Configuration, MetaData, ResourceType } from '../_openapi/portfolio-optimizer';
import { DataExportApi, DataExportRequest } from '../_openapi/portfolio-optimizer/apis/DataExportApi';
import { downloadFile } from '../utils/downloadFile';
import { processFilter } from '../widgets/filters/filterUtils';
import { defaultApiConfig } from './defaultApiConfig';

const dataExportApi = new DataExportApi(new Configuration(defaultApiConfig));

export const useDataExport = (resourceType: ResourceType, metaData?: MetaData) =>
    useMutation({
        mutationFn: async ({
            sorting,
            columnFilters,
            columns,
        }: {
            sorting?: SortingState;
            columnFilters?: ColumnFiltersState;
            columns: string[];
        }) => {
            const request: DataExportRequest = {
                resourceType,
                bodyDataExport: {
                    columns,
                    metaData,
                },
            };

            if (sorting?.length) {
                request.sortLabel = snakeCase(sorting[0].id);
                request.sortDesc = sorting[0].desc;
            }

            if (columnFilters?.length) {
                request.bodyDataExport!.filters = columnFilters.map(processFilter);
            }

            const file = await dataExportApi.dataExport(request);
            return downloadFile(
                `${resourceType}_table_export_${format(new Date(), 'MM_dd_yyyy')}.xlsx`,
                window.URL.createObjectURL(file),
            );
        },
    });
